var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-expansion-panels",
        {
          model: {
            value: _vm.expandedArray,
            callback: function($$v) {
              _vm.expandedArray = $$v
            },
            expression: "expandedArray"
          }
        },
        [
          _c(
            "v-expansion-panel",
            [
              _c(
                "v-expansion-panel-header",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.$t("components.advance.panelTitle")) +
                              ": "
                          )
                        ]),
                        _c("span", [
                          _c("b", { staticClass: "green--text" }, [
                            _vm._v(
                              _vm._s(
                                typeof _vm.modelAdvances !== "undefined"
                                  ? _vm.modelAdvances.length
                                  : ""
                              )
                            )
                          ])
                        ])
                      ]),
                      _c("v-spacer"),
                      _vm.countAdvanceErrors !== 0
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "mr-7",
                              attrs: {
                                small: "",
                                color: "error",
                                "text-color": "white"
                              }
                            },
                            [
                              _c("v-icon", [_vm._v("warning")]),
                              _vm._v(_vm._s(_vm.countAdvanceErrors))
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-card-text",
                        [
                          _c("simple-advance-list", {
                            attrs: {
                              clearable: _vm.clearable,
                              "validation-model": _vm.validationModel,
                              "model-advances": _vm.contextAdvances,
                              "max-date": _vm.maxDate,
                              readonly: _vm.readonly
                            },
                            on: {
                              removeAdvanceItem: _vm.removeAdvance,
                              "update:modelAdvances": function($event) {
                                _vm.contextAdvances = $event
                              },
                              "update:model-advances": function($event) {
                                _vm.contextAdvances = $event
                              }
                            }
                          }),
                          _vm.isAddButtonVisible
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { color: "accent" },
                                  on: {
                                    click: function($event) {
                                      return _vm.addAdvance()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("global.add")))]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }